import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=3e50a369&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e50a369",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\kaixinshequ-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e50a369')) {
      api.createRecord('3e50a369', component.options)
    } else {
      api.reload('3e50a369', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=3e50a369&scoped=true", function () {
      api.rerender('3e50a369', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/formConfig/edit.vue"
export default component.exports